FeedsApp.Views.NuFeedHistoryRow = ReadOnlyViewStandardModelEdition.extend({
    containerSelector: '.feed-history-table',
    templateUrl: '/assets/js/feeds/history/templates/feed-history-row.html',
    tagName: 'tr'
});